<template>
  <img class="gia-photo" :src="siteSettings.images.giaPhoto" alt="gia" />
</template>

<script lang="ts" setup>
import { useStore } from '@/store';
import { computed } from 'vue';

const { state } = useStore();
const siteSettings = computed(() => state.results.siteSettings);
</script>

<style lang="scss" scoped>
.gia-photo {
  display: block;
  max-width: 42px;
}
</style>
